export enum ThemeEnum {
    DEFAULT = 'Default',
    LIGHT = 'Light',
    DARK = 'Dark'
}